export enum ProductUrlSourceType {
    Default = 'all',
    Favourite = 'favourite',
    File = 'file'
}
